// frontend/src/services/signupAttribution.js
// Which crowmobile.com page a signup came from. Search pages link here with
// utm_* tags; the backend's /marketing-analytics/track/* endpoints already
// store them (and the admin dashboard reads them), but nothing called them
// since the old static site was retired. Analytics must never block a
// signup, so nothing here throws.
import { api } from './api';

export const STORAGE_KEY = 'crow_signup_source';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

const read = (storage) => {
  try {
    return JSON.parse(storage.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
};

const newSessionId = () =>
  (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`);

export async function captureSignupSource(search, storage = window.sessionStorage) {
  const existing = read(storage);
  if (existing) return existing;

  const params = new URLSearchParams(search || '');
  if (!params.get('utm_source')) return null;

  const source = { session_id: newSessionId() };
  UTM_KEYS.forEach((key) => {
    if (params.get(key)) source[key] = params.get(key).slice(0, 255);
  });
  storage.setItem(STORAGE_KEY, JSON.stringify(source));

  try {
    await api.post('/marketing-analytics/track/pageview', {
      ...source,
      page_path: '/register',
      page_title: document.title,
      referrer: document.referrer || null,
    });
  } catch {
    // Analytics is best-effort.
  }
  return source;
}

export async function recordSignupComplete(userId, storage = window.sessionStorage) {
  const source = read(storage);
  if (!source) return;
  storage.removeItem(STORAGE_KEY);
  try {
    await api.post('/marketing-analytics/track/conversion', {
      session_id: source.session_id,
      step: 'signup_complete',
      user_id: userId ?? null,
    });
  } catch {
    // Analytics is best-effort.
  }
}
